import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { removeEmpty } from '../../utils/object';

export const analyticsApi = createApi({
  reducerPath: 'analyticsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (h, { getState }) => {
      const token = getState().auth.token;
      if (token) h.set('authorization', `Bearer ${token}`);
      return h;
    },
  }),
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: (filters) => {
        const params = removeEmpty(filters);
        return {
          url: 'analytics/dashboard',
          ...(Object.keys(params).length > 0 && { params: params }),
        };
      },
    }),

    getFilters: builder.query({
      query: (filters) => {
        const params = removeEmpty(filters);
        return {
          url: 'analytics/filters',
          ...(Object.keys(params).length > 0 && { params: params }),
        };
      },
    }),
  }),
});

export const { useGetDashboardQuery, useGetFiltersQuery } = analyticsApi;
